export default function isImage(url) {
    const imageExtensions = ["jpg", "jpeg", "png", "gif"];
    const extension = url.split('.').pop().toLowerCase();

    return imageExtensions.includes(extension);
}
